"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JOB_NAMES = exports.QUEUE_NAMES = exports.ACCOUNTING_SYNC_LOG_PREFIX = void 0;
/** Shared log prefix — grep `accounting-sync` across client-api, business-api, and worker. */
exports.ACCOUNTING_SYNC_LOG_PREFIX = "[accounting-sync]";
exports.QUEUE_NAMES = {
    workerHealthCheck: "worker-health-check",
    /** Xero accounting BullMQ queue: failed-row batch retry + allocate payment after escrow/instant release. */
    accountingSync: "accounting-sync",
    /** Canonical payment provider reconciliation (Finmo → provider_* tables). */
    paymentReconciliation: "payment-reconciliation",
    recurringInvoices: "recurring-invoices",
};
exports.JOB_NAMES = {
    workerHealthCheckPublish: "worker-health-check-publish",
    /** Cron / manual: scan FAILED Xero invoice sync rows and retry. */
    accountingFailedInvoiceSyncRetryRun: "accounting-sync-retry-failed",
    /** After escrow release: POST Xero Payment against existing ACCREC. */
    accountingSyncAllocatePayment: "accounting-sync-allocate-payment",
    /** Cron / event: reconcile provider payment state into canonical tables. */
    paymentReconciliationRun: "payment-reconciliation-run",
    recurringInvoiceGenerate: "recurring-invoice-generate",
    scheduledInvoiceReminderSend: "scheduled-invoice-reminder-send",
    kybReviewTimeoutCheck: "kyb-review-timeout-check",
    dailyDigestSend: "daily-digest-send",
};
